import { lazy } from 'react';

const list = lazy(() => import('./List'));
const show = lazy(() => import('./Show'));

export { list, show };
